import React from 'react';
import type { DrawerTabType } from '../../../../types/usersDemo';

interface DrawerTabsProps {
  activeTab: DrawerTabType;
  onChange: (tab: DrawerTabType) => void;
}

export const Tabs: React.FC<DrawerTabsProps> = ({ activeTab, onChange }) => {
  return (
    <div style={{
      display: 'flex',
      borderBottom: '1px solid #E2E8F0',
      marginBottom: '24px',
      paddingLeft: 0,
      paddingRight: 0,
    }}>
      {([
        { id: 'profile', label: 'Profile' },
        { id: 'activity', label: 'Activity' },
        { id: 'support', label: 'Support' },
      ] as Array<{ id: DrawerTabType; label: string }>).map((tab) => (
        <button
          key={tab.id}
          onClick={() => onChange(tab.id)}
          style={{
            padding: '12px 24px',
            border: 'none',
            background: 'transparent',
            cursor: 'pointer',
            fontWeight: activeTab === tab.id ? 600 : 400,
            color: activeTab === tab.id ? '#000' : '#666',
            borderBottom: activeTab === tab.id ? '2px solid #000' : '2px solid transparent',
            fontSize: '14px',
            transition: 'all 0.2s ease',
          }}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default Tabs;


